import Parseable from '@/misc/Parseable';
import { LocationApiEntity } from '@/interfaces/LocationApiEntity';

/**
 * Location representation
 */
export default class Location extends Parseable {
    public id!: string;
    public name!: string;

    public static parseFromObject(object: LocationApiEntity) {
        const location = new Location();
        location.id = object.id_location;
        location.name = object.name_app;
        return location;
    }

    public parseToObject(): Partial<Location> {
        return { ...this };
    }
}
